(function () {
  'use strict';

  var TAB_KEY = 'ctAgentTab';
  var ACCESS_KEY = 'ctAgentAccess';

  function norm(value) {
    var s = String(value || '').toLowerCase();
    try {
      s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
    } catch (e) {}
    return s;
  }

  function save(storage, key, value) {
    try {
      window[storage].setItem(key, value);
    } catch (e) {}
  }

  function load(storage, key) {
    try {
      return window[storage].getItem(key);
    } catch (e) {
      return null;
    }
  }

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  // Remember a successful access-code entry so agents aren't asked on every visit.
  function watchLock(days) {
    var lock = document.getElementById('agent-lock-screen');
    if (!lock || !(days > 0)) return;
    if (document.documentElement.classList.contains('agent-access-ok')) return;
    var observer = new MutationObserver(function () {
      if (lock.style.display === 'none') {
        save('localStorage', ACCESS_KEY, String(Date.now()));
        observer.disconnect();
      }
    });
    observer.observe(lock, { attributes: true, attributeFilter: ['style'] });
  }

  function AgentHub(root) {
    this.root = root;
    this.nav = root.querySelector('[data-agent-cats]');
    this.searchWrap = root.querySelector('[data-agent-search-wrap]');
    this.input = root.querySelector('[data-agent-search]');
    this.status = root.querySelector('[data-agent-status]');
    this.cats = Array.prototype.slice.call(document.querySelectorAll('[data-agent-cat]'));
    this.buttons = [];
    this.active = null;
    if (this.cats.length && this.nav) this.build();
  }

  AgentHub.prototype.build = function () {
    var self = this;
    this.nav.innerHTML = '';
    this.buttons = this.cats.map(function (cat) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'agent-cats__btn';
      button.setAttribute('aria-controls', cat.id);
      button.setAttribute('aria-pressed', 'false');

      var name = document.createElement('span');
      name.className = 'agent-cats__name';
      name.textContent = cat.getAttribute('data-title') || '';
      if (cat.hasAttribute('data-new')) {
        var badge = document.createElement('span');
        badge.className = 'agent-badge';
        badge.textContent = cat.getAttribute('data-new') || 'New';
        name.appendChild(document.createTextNode(' '));
        name.appendChild(badge);
      }

      var meta = document.createElement('span');
      meta.className = 'agent-cats__meta';
      meta.textContent = (cat.getAttribute('data-count') || '0') + ' ' + (cat.getAttribute('data-unit') || '');

      button.appendChild(name);
      button.appendChild(meta);
      button.addEventListener('click', function () {
        if (self.input) self.input.value = '';
        self.activate(cat, true);
      });
      self.nav.appendChild(button);
      return button;
    });
    this.nav.hidden = false;

    if (this.searchWrap && this.input) {
      this.searchWrap.hidden = false;
      if (!this.input.hasAttribute('data-agent-bound')) {
        this.input.setAttribute('data-agent-bound', '');
        var timer;
        this.input.addEventListener('input', function () {
          clearTimeout(timer);
          timer = setTimeout(function () {
            if (window.CTAgentHub) window.CTAgentHub.filter();
          }, 80);
        });
        this.input.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && window.CTAgentHub) {
            event.target.value = '';
            window.CTAgentHub.filter();
          }
        });
      }
    }

    var start = this.find(this.hashKey()) || this.find(load('sessionStorage', TAB_KEY)) || this.cats[0];
    this.activate(start, false);
    if (this.input && this.input.value) this.filter();
  };

  AgentHub.prototype.hashKey = function () {
    try {
      return decodeURIComponent((window.location.hash || '').slice(1));
    } catch (e) {
      return '';
    }
  };

  AgentHub.prototype.key = function (cat) {
    return cat.getAttribute('data-anchor') || cat.id;
  };

  AgentHub.prototype.find = function (key) {
    if (!key) return null;
    for (var i = 0; i < this.cats.length; i++) {
      if (this.key(this.cats[i]) === key || this.cats[i].id === key) return this.cats[i];
    }
    return null;
  };

  AgentHub.prototype.showAllRows = function () {
    this.cats.forEach(function (cat) {
      each(cat.querySelectorAll('[data-agent-row], [data-agent-group]'), function (el) {
        el.hidden = false;
      });
    });
  };

  AgentHub.prototype.activate = function (target, remember) {
    if (!target || this.cats.indexOf(target) === -1) return;
    this.active = target;
    this.showAllRows();
    this.cats.forEach(function (cat, i) {
      var on = cat === target;
      cat.hidden = !on;
      if (this.buttons[i]) this.buttons[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }, this);
    if (this.status) this.status.textContent = '';
    if (remember) {
      var key = this.key(target);
      save('sessionStorage', TAB_KEY, key);
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', '#' + encodeURIComponent(key));
      }
    }
  };

  AgentHub.prototype.filter = function () {
    if (!this.input) return;
    var raw = this.input.value.trim();
    var query = norm(raw);
    if (!query) {
      this.activate(this.active || this.cats[0], false);
      return;
    }

    var terms = query.split(/\s+/);
    var total = 0;
    this.buttons.forEach(function (button) {
      button.setAttribute('aria-pressed', 'false');
    });

    this.cats.forEach(function (cat) {
      var catHits = 0;
      each(cat.querySelectorAll('[data-agent-group]'), function (group) {
        var hits = 0;
        each(group.querySelectorAll('[data-agent-row]'), function (row) {
          if (!row._agentText) row._agentText = norm((row.getAttribute('data-search') || '') + ' ' + row.textContent);
          var match = terms.every(function (term) {
            return row._agentText.indexOf(term) !== -1;
          });
          row.hidden = !match;
          if (match) hits++;
        });
        group.hidden = hits === 0;
        catHits += hits;
      });
      cat.hidden = catHits === 0;
      total += catHits;
    });

    if (this.status) {
      this.status.textContent = total
        ? total + (total === 1 ? ' tour matches' : ' tours match') + ' “' + raw + '”'
        : 'No tours match “' + raw + '”. Try a place, tour name or code.';
    }
  };

  function init() {
    var root = document.querySelector('[data-agent-hub]');
    if (!root) return;
    watchLock(parseInt(root.getAttribute('data-remember-days') || '0', 10));
    window.CTAgentHub = new AgentHub(root);
  }

  function reveal(event) {
    var hub = window.CTAgentHub;
    if (!hub || !event.target) return;
    var cat = event.target.closest ? event.target.closest('[data-agent-cat]') : null;
    if (!cat && event.target.querySelector) cat = event.target.querySelector('[data-agent-cat]');
    if (!cat) return;
    if (hub.input) hub.input.value = '';
    hub.activate(cat, false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Links such as #queenstown select that list.
  window.addEventListener('hashchange', function () {
    var hub = window.CTAgentHub;
    if (!hub) return;
    var cat = hub.find(hub.hashKey());
    if (!cat) return;
    if (hub.input) hub.input.value = '';
    hub.activate(cat, false);
  });

  // Theme editor: rebuild after edits and show the list being edited.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () {
    setTimeout(init, 0);
  });
  document.addEventListener('shopify:section:select', reveal);
  document.addEventListener('shopify:block:select', reveal);
})();
